/**
 * @generated SignedSource<<d39d99891c1e2005224c29d5ff3bba3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleShiftBar$data = {
  readonly durationSeconds: number;
  readonly formattedEndAtTime: string;
  readonly formattedStartAtTime: string;
  readonly scheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly secondaryScheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly startAtSecondsFromMidnight: number;
  readonly status: EmployeeShiftStatus;
  readonly " $fragmentType": "EmployeeScheduleShiftBar";
};
export type EmployeeScheduleShiftBar$key = {
  readonly " $data"?: EmployeeScheduleShiftBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftBar">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleShiftBar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedStartAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedEndAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAtSecondsFromMidnight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "scheduleType",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleSecondaryType",
      "kind": "LinkedField",
      "name": "secondaryScheduleType",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "EmployeeShift",
  "abstractKey": null
};
})();

(node as any).hash = "a508c4684db96be14682f0f1b0dd579e";

export default node;
